// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"9437d457","532":"66781da6","642":"720bbfc8","701":"852ce526","916":"0dcbd679"}[chunkId] + ".css";
};